module.exports = __webpack_public_path__ + "static/media/NotEligibleSorry.376f2662.svg";